import { useNavigate } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="billing-cancel-page"
      className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6"
    >
      <div className="max-w-md w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-soft text-center">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center shadow-inner">
          <XCircle className="w-7 h-7 text-slate-500" />
        </div>
        <h1 className="mt-4 font-outfit text-2xl font-bold tracking-tight text-[#0F172A]">
          Checkout cancelled
        </h1>
        <p className="mt-2 font-figtree text-sm text-[#475569] leading-relaxed">
          No charge was made. You're still on your current plan — you can
          upgrade anytime from the account page.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <Button
            data-testid="billing-cancel-account-btn"
            onClick={() => navigate("/account")}
            className="rounded-full bg-[#0F172A] hover:bg-[#1E293B] text-white font-figtree text-sm font-medium px-6 py-5"
          >
            Back to account
          </Button>
          <Button
            data-testid="billing-cancel-app-btn"
            onClick={() => navigate("/app")}
            variant="outline"
            className="rounded-full border-slate-200 hover:bg-slate-50 font-figtree text-sm"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Return to app
          </Button>
        </div>
      </div>
    </div>
  );
}
